import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MixPanel from 'utils/mixpanelService';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import StarIcon from './star-filled.svg';
import SponsorItems from './SponsorItems';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonRoot: {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  starIcon: {
    marginRight: 11,
    height: 14,
    marginBottom: 2,
  },
  popper: {
    zIndex: 999,
    width: 340,
    maxHeight: 500,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-1em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
  },
  paper: {
    zIndex: 999,
    padding: 15,
    borderRadius: '4px !important',
    boxShadown: '0 0 41px 0 rgba(0,0,0,0.10)',
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
});

class SponsorsMenu extends React.PureComponent {
  state = {
    open: false,
    arrowRef: null,
  };

  handleToggle = () => {
    const { open } = this.state;
    this.setState({ open: !open });

    if (!open) {
      MixPanel.track('Sponsors clicked');
    }
  };

  handleItemClick = ({ shortName, slug }) => {
    MixPanel.track('Sponsors item clicked', {
      shortName,
      slug,
    });
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const { classes } = this.props;
    const { open, arrowRef } = this.state;
    return (
      <div className={classes.root}>
        <IconButton
          buttonRef={node => {
            this.anchorEl = node;
          }}
          aria-owns={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={this.handleToggle}
          classes={{ root: classes.buttonRoot }}
          disableRipple
          disableTouchRipple
        >
          <img src={StarIcon} alt="Sponsor" className={classes.starIcon} />
          Sponsors
        </IconButton>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          transition
          disablePortal={false}
          modifiers={{
            arrow: {
              enabled: true,
              element: arrowRef,
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <>
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <Paper className={classes.paper}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <div>
                      <SponsorItems onClick={this.handleItemClick} />
                    </div>
                  </ClickAwayListener>
                </Paper>
              </>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

SponsorsMenu.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
};

export default compose(
  withStyles(styles),
  withRouter,
)(SponsorsMenu);
